import type { SolanaProvider } from '@particle-network/connector-core';

export const isConnected = (provider: SolanaProvider) => {
  // some provider not defined `isConnected`, such as Trust Wallet.
  if (provider && typeof provider.isConnected === 'boolean') {
    return provider.isConnected;
  }

  return Boolean(provider?.publicKey);
};
